import { motion } from "framer-motion";
import { BUFFET_1, BUFFET_2 } from "../../lib/assets";
import { useLang } from "../../lib/i18n";

const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Gallery = () => {
  const { t } = useLang();
  return (
    <section id="galerie" className="bg-[#FAFAFA] py-24 md:py-32" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16"
        >
          <div>
            <p className="font-script text-[#C9A03C] text-2xl mb-4">{t.gallery.eyebrow}</p>
            <h2 className="font-serif-lux text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight text-logo-gradient pb-1">
              {t.gallery.title}
            </h2>
          </div>
          <p className="text-[#0A192F]/60 font-light max-w-sm leading-relaxed">{t.gallery.intro}</p>
        </motion.div>

        <div className="grid md:grid-cols-12 gap-6">
          <motion.figure
            custom={0}
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            className="md:col-span-7 overflow-hidden group"
            data-testid="gallery-image-1"
          >
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={BUFFET_1}
                alt={t.gallery.cap1}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <figcaption className="mt-4 flex items-baseline gap-3">
              <span className="font-serif-lux text-[#C9A03C] text-xl">I.</span>
              <span className="text-sm text-[#0A192F]/60 font-light tracking-wide">{t.gallery.cap1}</span>
            </figcaption>
          </motion.figure>

          <motion.figure
            custom={1}
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            className="md:col-span-5 md:mt-20 overflow-hidden group"
            data-testid="gallery-image-2"
          >
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src={BUFFET_2}
                alt={t.gallery.cap2}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <figcaption className="mt-4 flex items-baseline gap-3">
              <span className="font-serif-lux text-[#C9A03C] text-xl">II.</span>
              <span className="text-sm text-[#0A192F]/60 font-light tracking-wide">{t.gallery.cap2}</span>
            </figcaption>
          </motion.figure>
        </div>
      </div>
    </section>
  );
};
